import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { MeoCartSummary } from '../../order-selection/minimum-enrollment-order/MeoCartSummary';
import { MoneyDisplay } from '../../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';
import { useRootStore } from '../../root/RootStoreHooks';

export interface MeoKitSelectionProps {
  isSocialLink?: boolean;
}

export const MeoKitSelection = observer<MeoKitSelectionProps>(({ isSocialLink }) => {
  const { t } = useTranslation();
  const root = useRootStore();
  const enrollmentKitSelection = root.moduleStores.enrollmentKitSelection!;
  const isMeoEnabled = enrollmentKitSelection?.isMeoEnabled;
  const minimumEnrollmentOrderPv =
    enrollmentKitSelection?.minimumEnrollmentOrderPv ?? root.moduleStores.socialLinkEntry!.minimumEnrollmentOrderPv;

  return isMeoEnabled || isSocialLink ? (
    <div className="mt-3">
      <h3 className="text-primary">{t('BuildMinimumEnrollmentOrder')}</h3>
      <p className="card-text">
        {t('BuildMinimumEnrollmentOrderHelp1')} <MoneyDisplay numberOnly price={minimumEnrollmentOrderPv} /> PV
        {t('BuildMinimumEnrollmentOrderHelp2')}
      </p>
      <MeoCartSummary />
    </div>
  ) : (
    <></>
  );
});
